import apiClient from "./base";

export const login = async (params: { username: string, password: string }) => {
    const response = await apiClient.post("/login.php", params);
    return response.data;
};